import Vue from 'vue';
import { mapState } from 'vuex';
import tinycolor from 'tinycolor2';
import Greview from '@/components/global/DinamicBlocks/Greview.vue';
import Cookies from 'universal-cookie';

export default {
  data() {
    return {
      isCookieModalOpen: false,
      isCookieBannerVisible: false
    }
  },
  methods: {
    cookieLaw() {
	  const cookies = new Cookies();
	  
	  if (!cookies.get('cookie_accepted')) {
		this.isCookieBannerVisible = true;
	  }
    },

    hideCookieBanner() {
      this.isCookieBannerVisible = false;
    },

    showCookieCustomizationModal() {
      this.isCookieModalOpen = true;
    },

    closeCookieModal() {
      this.isCookieModalOpen = false;
    },

	configureConsent(preferences) {
		const consentState = {
			'ad_storage': preferences.technical ? 'granted' : 'denied',
			'ad_user_data': preferences.analytics ? 'granted' : 'denied',
			'ad_personalization': preferences.profiling ? 'granted' : 'denied',
			'analytics_storage': preferences.analytics ? 'granted' : 'denied'
		};
		
		if (this.$gtm) {
			this.$gtm.push({
				event: 'consent',
				consent_state: consentState
			});
		}
		
		if (this.$gtag) {
			this.$gtag.query('consent', 'update', consentState);

			if(Object.values(preferences).every(value => value === true)){
				this.$gtag.optIn();
			}
			if(Object.values(preferences).every(value => value === false)){
				this.$gtag.optOut();
			}
		}
	},

    onCookiePreferencesSaved(preferences) {
	  this.configureConsent(preferences)
      this.hideCookieBanner();
      this.closeCookieModal();
    },

    onCookieBannerAccepted() {
	  const cookies = new Cookies();
      this.hideCookieBanner();
	  this.$gtag.optIn();
	  cookies.set('cookie_accepted', 'true');
    },

    onCookieBannerRejected() {
	  const cookies = new Cookies();
      this.hideCookieBanner();
	  this.$gtag.optOut();
	  cookies.set('cookie_accepted', 'true');
    },

    onCookieBannerCustomize() {
      this.showCookieCustomizationModal();
    },
    tinycolor,
    // nuova possibilità di rendering dinamico dei componenti basati sulla ricerca di un ID
    renderComponentInDiv(component, divId) {
      const div = document.getElementById(divId);
      if (div) {
        new Vue({
          parent: this,
          render: h => h(component)
        }).$mount(`#${divId}`);
      } else {
        // console.warn(`${divId} not found.`);
      }
    }
  },
  computed: {
    ...mapState({
      isBrowser: state => state.app.isBrowser,
      network: state => state['booking-networks'].getBookingNetworksRequest.data,
    }),
    isSimpleView() {
      return this.network.property_view == this.$const('property_view', 'SIMPLE');
    },
    isShowChildren() {
      return !!this.network.is_search_show_children;
    },
    isShowRooms() {
      return !!this.network.is_search_show_rooms;
    },
    isSingleProperty() {
      return !!this.network.single_property_id;
    },
    networkConfig() {
      if (!this.network.config) return {};
      
      return JSON.parse(this.network.config)
    }
  },
  mounted() {
    // esempio di render basato su ID. Si passa nome componente e poi ID tra ''
    this.renderComponentInDiv(Greview, 'google-review');
  },
  watch: {
    '$i18n.locale'(val) {
      this.$moment.locale(this.$i18n.locale);
    }
  }
}
